import moment from "moment-timezone";

export function formatDate(date: string | undefined) {
  if(date) {
    return moment(date).tz("Europe/Paris").subtract(2, "hours").format("DD/MM/YYYY à HH:mm:ss");
  }
  return "";
}
